import { Grid, Typography, makeStyles } from '@material-ui/core';
import React from 'react';
import DataView from '../../components/DataView';
import ContainerDataView from './ContainerDataView';

const useStyles = makeStyles(theme => ({
  subsectionTitle: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1)
  }
}));

const ExportadorView = ({ values, isPhone }) => {
  const classes = useStyles();
  return (
    <>
      <ContainerDataView title="Datos del Exportador">
        <Grid container spacing={4} alignItems="flex-start">
          <Grid container item xs={12} md={6} spacing={isPhone ? 1 : 0}>
            <Grid container item className={classes.subsectionTitle}>
              <Typography
                variant="subtitle1"
                color="textSecondary"
                gutterBottom
              >
                Datos de la empresa
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <DataView
                label="RUC"
                value={values.rucExportador}
                isPhone={isPhone}
              />
            </Grid>
            <Grid item xs={12}>
              <DataView
                label="Razón Social"
                value={values.razonSocialExportador}
                isPhone={isPhone}
              />
            </Grid>
            <Grid item xs={12}>
              <DataView
                label="Dirección"
                value={values.direccionExpo}
                isPhone={isPhone}
              />
            </Grid>
            <Grid item xs={12}>
              <DataView
                label="Ciudad"
                value={values.ciudadExportador}
                isPhone={isPhone}
              />
            </Grid>
            <Grid item xs={12}>
              <DataView
                label="Código Postal"
                value={values.codigoPostal}
                isPhone={isPhone}
              />
            </Grid>
          </Grid>
          <Grid container item xs={12} md={6} spacing={isPhone ? 1 : 0}>
            <Grid container item className={classes.subsectionTitle}>
              <Typography
                variant="subtitle1"
                color="textSecondary"
                gutterBottom
              >
                Datos del Representante Legal
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <DataView
                label="Nombre del Contacto"
                value={values.personaContacto}
                isPhone={isPhone}
              />
            </Grid>
            <Grid item xs={12}>
              <DataView
                label="Teléfono/Fax"
                value={values.telefono}
                isPhone={isPhone}
              />
            </Grid>
            <Grid item xs={12}>
              <DataView
                label="Correo electrónico"
                value={values.emailExpo}
                isPhone={isPhone}
              />
            </Grid>
          </Grid>
        </Grid>
      </ContainerDataView>
    </>
  );
};

export default ExportadorView;
